import { render, staticRenderFns } from "./FlashcardsTab.vue?vue&type=template&id=6e6d2082&scoped=true"
import script from "./FlashcardsTab.vue?vue&type=script&lang=js"
export * from "./FlashcardsTab.vue?vue&type=script&lang=js"
import style0 from "./FlashcardsTab.vue?vue&type=style&index=0&id=6e6d2082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6d2082",
  null
  
)

export default component.exports